import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { TranslationsModule } from '../../translations/translations.module';
import { FilterOptionsListComponent } from './FilterOptionsList.component';

@NgModule({
    declarations: [FilterOptionsListComponent],
    exports: [FilterOptionsListComponent],
    providers: [],
    imports: [CommonModule, FormsModule, CoreUiModule, TranslationsModule]
})
export class FilterOptionsListModule {}
